/**
* Visual Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Visual Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

( function( app ) {
  const COMPONENT = {

    className: 'visual-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function( ) {
      const _this = this;
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        _this.initSliders( formId, currentPage );
        if ( $( '#gform_page_' + formId +'_' + currentPage ).hasClass( 'decline-page' ) ) {
          console.log( 'hasClass' );
          $( '.progress-bar-container' ).addClass( 'c-hidden' );
          $( '.visual-form-container-center' ).addClass( 'c-content-center' );
          $( '.decline-page-image, .decline-page-overlay' ).removeClass( 'c-hidden' );
        }
      } );
    },
    finalize: function() {
    },
    initSliders: function( formId, currentPage ) {
      const page = $( '#gform_page_' + formId +'_' + currentPage )[0];

      if ( page.length <= 0 ) {
        return;
      }

      const numberFormat = {
        // 'to' the formatted value. Receives a number.
        to: function( value ) {
          return value;
        },
        // 'from' the formatted value.
        // Receives a string, should return a number.
        from: function( value ) {
          return Number( value );
        },
      };

      // Find all the mood slider render elements
      const moodSliders = $( page ).find( '.mood-slider' );

      if ( moodSliders.length > 0 ) {
        moodSliders.each( function( key, slider ) {
          const renderMood = slider.querySelector( '.render-mood-slider' );

          noUiSlider.create( renderMood, {
            start: 1,
            range: {
              'min': 1,
              'max': 5,
            },
            connect: 'lower',
            tooltips: [
              false,
            ],
            step: 1,
            pips: {
              mode: 'steps',
              format: numberFormat,
            },
          } );

          const noUiValue = slider.querySelectorAll( '[data-value]' );
          noUiValue.forEach( ( item ) => {
            let text = '';
            switch ( item.dataset.value ) {
              case '1':
                text = 'Never';
                break;
              case '2':
                text = 'Rarely';
                break;
              case '3':
                text = 'Sometimes';
                break;
              case '4':
                text = 'Often';
                break;
              case '5':
                text = 'Always';
                break;
              default:
                text = 'No Value Found';
                break;
            }
            item.innerHTML = text;
          } );
        } );
      }
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'visual-form', COMPONENT );
} )( app );
